import { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { Formik, ErrorMessage } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { createSignUp } from "../../redux/actions/auth";
import PhoneNumberField from "../PhoneNumberField";
import SocialLoginActions from "./SocialLoginActions";
import EnterOtp from "./EnterOtp";
import { parsePhoneNumber } from "react-phone-number-input";

const validationSchema = yup.object({
  name: yup.string().required("Name is required"),
  email: yup
    .string()
    .email("Enter a valid email")
    .required("Email is required"),
  phone_number: yup.string().nullable(),
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/\d/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "Password must contain at least one special character"
    ),
  terms: yup.boolean().oneOf([true], "You must accept the terms"),
});

const Signup = ({ show, onHide, openSignin }) => {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [userId, setUserId] = useState("");

  const initialValues = {
    name: "",
    email: "",
    phone_number: "",
    password: "",
    terms: false,
  };

  // social logins
  // const handleSocialLogin = async (provider) => {
  //     try {
  //         const res = await dispatch(socialSignup({ provider }));
  //         if (res.success) {
  //             toast.success(`${provider.charAt(0).toUpperCase() + provider.slice(1)} login successful!`);
  //             onHide(); // Close signup modal
  //         } else {
  //             toast.error(res.message || "Social login failed");
  //         }
  //     } catch (err) {
  //         toast.error(err.message || "Something went wrong");
  //     }
  // };

  const extractCountryCode = (phoneNumber) => {
    if (!phoneNumber) return { country_code: "", phone_number: "" };

    try {
      const parsed = parsePhoneNumber(phoneNumber);
      if (parsed) {
        return {
          country_code: `+${parsed.countryCallingCode}`,
          phone_number: parsed.nationalNumber,
        };
      }
    } catch (error) {
      console.log("Error parsing phone number:", error);
    }

    return { country_code: "", phone_number: phoneNumber.replace(/\D/g, "") };
  };

  const handleFormSubmit = async (values, { resetForm, setSubmitting }) => {
    const { country_code, phone_number } = extractCountryCode(
      values.phone_number
    );

    const payload = {
      name: values.name,
      email: values.email,
      phone_number: phone_number || "",
      country_code: country_code || "",
      password: values.password,
    };

    try {
      const response = await dispatch(createSignUp(payload)).unwrap();
      toast.success(response?.message || "OTP sent to your email!");
      setUserEmail(values.email);
      setUserId(response?.data?._id);
      resetForm();
      onHide();
      setShowOtpModal(true);
    } catch (error) {
      console.error("Signup Error:", error);
      debugger;
      toast.error(error || "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleOtpSuccess = () => {
    setShowOtpModal(false);
    openSignin();
  };

  return (
    <>
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton className="border-0" />
        <Modal.Body className="pt-0">
          <div className="commn-modal-signin">
            <h2>Sign Up</h2>
            <p>
              It was popularised in the 1960s with the release of Letraset
              sheets containing Lorem Ipsum.
            </p>

            {/* Social Signin */}
            <SocialLoginActions />

            {/* Form */}
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleFormSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              }) => (
                <Form onSubmit={handleSubmit}>
                  {/* Name */}
                  <Form.Group className="mb-3" controlId="signupName">
                    <Form.Control
                      type="text"
                      placeholder="Name"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={touched.name && errors.name}
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>

                  {/* Email */}
                  <Form.Group className="mb-3" controlId="signupEmail">
                    <Form.Control
                      type="email"
                      placeholder="Email"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={touched.email && errors.email}
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>

                  {/* Phone */}
                  <div className="modal-phn-set mb-3">
                    <PhoneNumberField
                      name="phone_number"
                      label="Phone"
                      placeholder="+44"
                      defaultCountry="GB"
                    />
                  </div>

                  {/* Password */}
                  <Form.Group
                    className="mb-3"
                    controlId="signupPassword"
                    style={{ position: "relative" }}
                  >
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={touched.password && errors.password}
                      style={{
                        background: "#F5F9FF",
                        borderRadius: "12px",
                        paddingRight: "45px",
                        height: "50px",
                      }}
                    />
                    <ErrorMessage
                      name="password"
                      component="div"
                      className="text-danger"
                    />

                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "15px",
                        top: "25px",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                      }}
                    >
                      {showPassword ? (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M12 5C7 5 2.73 8.11 1 12C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 12C21.27 8.11 17 5 12 5Z"
                            stroke="#2C3E50"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <circle
                            cx="12"
                            cy="12"
                            r="3"
                            stroke="#2C3E50"
                            strokeWidth="2"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M17.94 17.94C16.23 19.24 14.21 20 12 20C7 20 2.73 16.89 1 13C1.63 11.61 2.62 10.36 3.88 9.32M9.9 4.24C10.58 4.08 11.28 4 12 4C17 4 21.27 7.11 23 11C22.37 12.39 21.38 13.64 20.12 14.68"
                            stroke="#2C3E50"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <line
                            x1="2"
                            y1="2"
                            x2="22"
                            y2="22"
                            stroke="#2C3E50"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                      )}
                    </span>
                  </Form.Group>

                  {/* Terms */}
                  <Form.Group className="mb-3" controlId="signupTerms">
                    <Form.Check
                      type="checkbox"
                      label="I’m agree to The Terms of Service and Privacy Policy"
                      name="terms"
                      checked={values.terms}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="terms"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="btn btn-primary w-100"
                  >
                    {isSubmitting ? "Creating Account..." : "Sign Up"}
                  </button>
                  <div className="bottom-sign-txt mt-3">
                    Do you have an account?{" "}
                    <button
                      type="button"
                      className="link-like"
                      onClick={() => {
                        onHide();
                        openSignin();
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#000",
                        cursor: "pointer",
                        padding: 0,
                      }}
                    >
                      Sign In
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>

      <EnterOtp
        show={showOtpModal}
        onHide={() => setShowOtpModal(false)}
        openResetPassword={handleOtpSuccess}
        email={userEmail}
        userId={userId}
      />
    </>
  );
};

export default Signup;
